import BaseApiClient from "./BaseApiClient";
import { ExecutionMode } from "@/enums/executionMode.enum";

export default class Drivers extends BaseApiClient {
  constructor() {
    super("v1/drivers");
  }

  read(driverId: string) {
    return this.axiosInstance({
      url: `/${driverId}`,
      method: "get",
    });
  }

  execute(
    driverId: string,
    data: any,
    executionMode: ExecutionMode = ExecutionMode.SYNC,
    comments: string = "",
    settings: any = {},
  ) {
    return this.axiosInstance({
      url: `/${driverId}/actions/execute`,
      data: {
        data: data,
        execution_mode: executionMode,
        comments: comments,
        settings: settings,
      },
      method: "post",
    });
  }
}
